import React, { memo, useMemo, useContext } from 'react';
import { Table } from 'tea-component';
import { context as Context } from '@gp/components/Context';
import Loading from '@gp/components/Loading';
import NoData from '@gp/components/NoData';
import DataTime from '@gp/components/DataTime';
import useTableList from './hooks/useTableList';
import { getColumns } from './utils/common';
import './index.scss';

const { autotip, scrollable } = Table.addons;

const LOADING = false;

interface MergeableTableProps {
  [keyName: string]: any;
}

function MergeableTable(props: MergeableTableProps) {
  const {} = props;

  const {
    loading,
    dataList: data,
    updateTime,
  }: HeadcountsContextTypes = useContext(Context) || {};

  const { records, colList } = useTableList({ sourceData: data });

  const columns = useMemo(() => getColumns(colList), [colList]);

  // 表格使用到的插件
  const addons = [
    scrollable({
      // maxHeight: 238,
    }),
    autotip({
      isLoading: LOADING,
      hideIcon: !LOADING, //loading状态显示图标，其他情况不显示
      emptyText: <span style={{ color: '#444' }}>No data yet.</span>,
      style: {
        height: 172,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
        margin: '0 auto',
      },
    }),
  ];

  return (
    <section className="dbg-studio-overall-details-finance-financials-table-content">
      {loading ? (
        <Loading loading style={{height: 260}} />
      ) : !data || !data?.dataList?.length ? (
        <NoData height={200} constomStyle={{ fontSize: 14 }} />
      ) : (
        <>
          {/* <DataTime
            className="dbg-studio-overall-details-finance-financials-update-time"
            dateType="Month"
            date={updateTime}
          /> */}
          <Table
            className="dbg-common-table finance-financials-table-list-table"
            verticalTop
            // bordered="all"
            records={records}
            recordKey="uniqueId"
            columns={columns}
            addons={addons}
          />
        </>
      )}
    </section>
  );
}

MergeableTable.defaultProps = {};

export default memo(MergeableTable);
